import { apiRequest, handleCall } from 'syft-acp-core/api/call'

/**
 * Retrieves a list of watchlist compliance.
 */
export const watchlistCompliance = ({ options = {} }): Promise<any> =>
  new Promise((resolve, reject) => {
    const req = apiRequest({ path: '/admin/watchlists/compliance', reqArgs: options })
    handleCall(req, resolve, reject, true, options)
  })
